import { CountUp } from 'countup.js';

document.addEventListener('DOMContentLoaded', function () {
    const countUpElements = document.querySelectorAll('[data-countup-number]');

    countUpElements.forEach(element => {
        const countTo = Number(element.getAttribute('data-countup-number'));

        if (!countTo) return;

        // set elements fixed width so it doesnt jump around
        const contentWidth = element.scrollWidth
        element.style.width = contentWidth + 'px';

        // set up animation
        new CountUp(element, countTo, {
            enableScrollSpy: true,
            scrollSpyOnce: true,
            onCompleteCallback: function () {
                // reset set up width
                element.style.width = 'auto';
            }
        });
    });
});